import { useEffect, useState } from "react";
import { dadosLogin } from "../../zustand/zuztand";
import { Link, useNavigate } from "react-router-dom";
import api from "../../services/api.js";
import "../dashboard-franquias/dashboard-franquias.css"



function DashboardFranquias(props) {
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const [dadosFranquias, setDadosFranquias] = useState([]);
    const [dadosSeparados, setDadosSeparados] = useState([]);
    const [totalFranqueados, setTotalFranqueados] = useState(0);
    const [totalColaboradores, setTotalColaboradores] = useState(0);
    const [totalFranquias, setTotalFranquias] = useState(0);
    const [totalEstados, setTotalEstados] = useState(0);
    const [totalCidades, setTotalCidades] = useState(0);
    const [totalGrupos, setTotalGrupos] = useState(0);
    const [arrayGrupos, setArrayGrupos] = useState([]);
    const [arrayRegioes, setArrayRegioes] = useState([]);


    const [dadosFornecedores, setDadosFornecedores] = useState([]);
    const [totalFornecedores, setTotalFornecedores] = useState(0);
    const [totalFornecedoresCatalogos, setTotalFornecedoresCatalogos] = useState(0);
    const [totalFranquiasInativas, setTotalFranquiasInativas] = useState(0);
    const [qtdPremium, setQtdPremium] = useState(0);
    const [qtdCompacta, setQtdCompacta] = useState(0);
    const [qtdQuiosque, setQtdQuiosque] = useState(0);
    const [qtdEstanteLudica, setQtdEstanteLudica] = useState(0);
    const [totalModalidades, setTotalModalidades] = useState(0);

    const [qtdgrupoA, setQtdgrupoA] = useState(0);
    const [qtdgrupoB, setQtdgrupoB] = useState(0);
    const [qtdgrupoC, setQtdgrupoC] = useState(0);

    const [norte, setNorte] = useState(0);
    const [nordeste, setNordeste] = useState(0);
    const [sul, setSul] = useState(0);
    const [sudeste, setSudeste] = useState(0);
    const [centroOeste, setCentroOeste] = useState(0);

    // Dados para as modalidades: os números abaixo representam valores absolutos
    // Para este exemplo, os números foram definidos de forma que a soma seja 100.
    const modalidadesData = [
        { modalidade: "Premium", quantidade: qtdPremium },
        { modalidade: "Compacta", quantidade: qtdCompacta },
        { modalidade: "Quiosque", quantidade: qtdQuiosque },
        { modalidade: "Estante Lúdica", quantidade: qtdEstanteLudica }
    ];

    function ListarFranquias() {

        api.get("/franquia_aniver_listar")
            .then((resp) => {
                setTotalFranquias(resp.data.length);
                setDadosFranquias(resp.data);
                separaUf(resp.data);
                separaCidades(resp.data);
                ListarModalidade(resp.data);
                ListarRegiao(resp.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function ListarInativas() {
        api.get("/franquia_inativas_listar")
            .then((resp) => {
                setTotalFranquiasInativas(resp.data.length);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function ListarModalidade(dados) {

        let tipo1 = [];
        let tipo2 = [];
        let tipo3 = [];
        let tipo4 = [];

        dados.map((item) => {
            if (item.tipo_franquia === "Premium") {
                tipo1.push(item);
            } else if (item.tipo_franquia === "Compacta") {
                tipo2.push(item);
            } else if (item.tipo_franquia === "Quiosque") {
                tipo3.push(item);
            } else if (item.tipo_franquia === "Estante Lúdica") {
                tipo4.push(item);
            }
        })

        setQtdPremium(tipo1.length);
        setQtdCompacta(tipo2.length);
        setQtdEstanteLudica(tipo4.length);
        setQtdQuiosque(tipo3.length);
        setTotalModalidades(tipo1.length + tipo2.length + tipo3.length + tipo4.length);
    }

    function ListarRegiao(dados) {

        let norte = [];
        let nordeste = [];
        let sul = [];
        let sudeste = [];
        let centroOeste = [];

        dados.map((item) => {
            if (item.regiao === "Norte") {
                norte.push(item);
            } else if (item.regiao === "Nordeste") {
                nordeste.push(item);
            } else if (item.regiao === "Sul") {
                sul.push(item);
            } else if (item.regiao === "Centro-Oeste") {
                centroOeste.push(item);
            } else if (item.regiao === "Sudeste") {
                sudeste.push(item);
            }
        })


        let grupoNorte = []
        grupoNorte.push({
            regiao: "Norte",
            qtd: norte.length
        })

        let grupoNordeste = []
        grupoNordeste.push({
            regiao: "Nordeste",
            qtd: nordeste.length
        })

        let grupoSudeste = []
        grupoSudeste.push({
            regiao: "Sudeste",
            qtd: sudeste.length
        })

        let grupoSul = []
        grupoSul.push({
            regiao: "Sul",
            qtd: sul.length
        })

        let grupoCentroOeste = []
        grupoCentroOeste.push({
            regiao: "Centro-Oeste",
            qtd: centroOeste.length
        })

        setArrayRegioes([...grupoNorte, ...grupoNordeste, ...grupoSul, ...grupoSudeste, ...grupoCentroOeste]);
    
    }

    function separaUf(dados) {
        // Agrupando os dados por uf_franquia
        const agrupados = dados.reduce((acc, item) => {
            const uf = item.uf_franquia;
            if (!acc[uf]) {
                acc[uf] = { uf_franquia: uf, qtd: 0 };
            }
            acc[uf].qtd++;
            return acc;
        }, {});

        // Convertendo o objeto de agrupamento em array
        setDadosSeparados(Object.values(agrupados).sort((a, b) => b.qtd - a.qtd));
        setTotalEstados(Object.values(agrupados).sort((a, b) => b.qtd - a.qtd).length);
        // console.log(dadosSeparados);
    }

    function separaCidades(dados) {
        // Usando flatMap para extrair e separar as cidades
        const cidades = dados.flatMap(item =>
            item.cidades_abrang.split(',').map(cidade => cidade.trim())
        );
        // Removendo duplicatas usando Set
        const cidadesSemRepetidas = [...new Set(cidades)];
        setTotalCidades(cidadesSemRepetidas.length);
    }

    function ListarFornecedores() {

        api.get("/fornecedores_combo_listar")
            .then((resp) => {
                // console.log(resp.data)
                setTotalFornecedores(resp.data.length);
                setDadosFornecedores(resp.data);
                ListarFornGrupo(resp.data)
            })
            .catch((err) => {
                console.log(err);
            });

    }

    function ListarFornGrupo(dados) {

        var grupoA = [];
        var grupoB = [];
        var grupoC = [];

        dados.map((item) => {
            if (item.grupo_forn === "A") {
                grupoA.push(item);
            } else if (item.grupo_forn === "B") {
                grupoB.push(item);
            } else if (item.grupo_forn === "C") {
                grupoC.push(item);
            }
        })

        let grupoa = []
        grupoa.push({
            grupo: "Grupo A",
            valor: grupoA.length
        })

        let grupob = []
        grupob.push({
            grupo: "Grupo B",
            valor: grupoB.length
        })

        let grupoc = []
        grupoc.push({
            grupo: "Grupo C",
            valor: grupoC.length
        })

        setArrayGrupos([...grupoa, ...grupob, ...grupoc]);

        // setTotalA(grupoA.length);
        setTotalGrupos(grupoA.length + grupoB.length + grupoC.length);

        //  console.log(arrayNovo)


    }

    function ListarFornecedoresComCatalogo() {
        api.get("/fornecedores_catalogo_listar")
            .then((resp) => {
                setTotalFornecedoresCatalogos(resp.data.length);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function ListarFranqueados() {
        api.get("/franqueados_aniver_listar")
            .then((resp) => {
                setTotalFranqueados(resp.data.length);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function ListarColaboradores() {
        api.get("/col_aniver_listar")
            .then((resp) => {
                setTotalColaboradores(resp.data.length);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    useEffect(() => {
        const executarFuncoesSequencialmente = async () => {
            ListarFranquias();
            await sleep(500);

            ListarInativas();
            await sleep(500);

            ListarFornecedores();
            await sleep(500);

            ListarFornecedoresComCatalogo();
            await sleep(500);

            ListarFranqueados();
            await sleep(500);

            ListarColaboradores();
            await sleep(500);
        };

        executarFuncoesSequencialmente();
    }, []);

    return (
        <div className="container-fluid dashboard">
            {/* Cabeçalho */}
            <div className="row mb-2">
                <div className="col div-dash-titulo">
                    <h3 className=" text-center text-white">Dashboard Comparativo Franqueadora</h3>
                </div>
                <div className="col-1 me-5">
                    <Link to="/dashboard" className="btn btn-success p-2 btn-sm " >Voltar </Link>
                </div>
            </div>

            {/* Seção Comparativa de Indicadores */}
            <div className="row mb-4">
                {/* Comparativo de Franquias (Ativas vs. Inativas) */}
                <div className="col-md-6 mb-3">
                    <div className="card h-100">
                        <div className="card-header bg-primary text-white">
                            Comparativo de Franquias
                        </div>
                        <div className="card-body">
                            <div className="row text-center">
                                <div className="col-6 border-end">
                                    <h6>
                                        <i className="bi bi-check2-circle"></i> Ativas
                                    </h6>
                                    <p className="display-4">{totalFranquias}</p>
                                </div>
                                <div className="col-6">
                                    <h6>
                                        <i className="bi bi-x-circle"></i> Inativas
                                    </h6>
                                    <p className="display-4">{totalFranquiasInativas}</p>
                                </div>
                            </div>
                            {/* Informações de total e taxa foram removidas conforme solicitado */}
                        </div>
                    </div>
                </div>

                {/* Comparativo de Fornecedores & Catálogos */}
                <div className="col-md-6 mb-3">
                    <div className="card h-100">
                        <div className="card-header bg-secondary text-white">
                            Comparativo de Fornecedores
                        </div>
                        <div className="card-body">
                            <div className="row text-center">
                                <div className="col-6 border-end">
                                    <h6>
                                        <i className="bi bi-truck"></i> Fornecedores
                                    </h6>
                                    <p className="display-5">{totalFornecedores}</p>
                                </div>
                                <div className="col-6">
                                    <h6>
                                        <i className="bi bi-book"></i> Catálogos
                                    </h6>
                                    <p className="display-5">{totalFornecedoresCatalogos}</p>
                                </div>
                            </div>
                            {/* Removido total e proporções calculadas */}
                        </div>
                    </div>
                </div>
            </div>

            {/* Indicadores Gerais Complementares */}
            <div className="row mb-4">
                {/* Cidades e Estados */}
                <div className="col-md-4 mb-3">
                    <div className="card text-white bg-info h-100">
                        <div className="card-body text-center">
                            <h6>
                                <i className="bi bi-geo-alt"></i> Cidades Abrangência
                            </h6>
                            <p className="display-7">{totalCidades}</p>
                            <h5>
                                <i className="bi bi-flag"></i> Estados: {totalEstados}
                            </h5>
                        </div>
                    </div>
                </div>
                {/* Franqueados */}
                <div className="col-md-4 mb-3">
                    <div className="card text-white bg-dark h-100">
                        <div className="card-body text-center">
                            <h6>
                                <i className="bi bi-people"></i> Franqueados
                            </h6>
                            <p className="display-6">{totalFranqueados}</p>
                        </div>
                    </div>
                </div>
                {/* Colaboradores */}
                <div className="col-md-4 mb-3">
                    <div className="card h-100">
                        <div className="card-body text-center">
                            <h6>
                                <i className="bi bi-person-badge"></i> Colaboradores
                            </h6>
                            <p className="display-6">{totalColaboradores}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Comparação de Distribuição */}
            <div className="row mb-4">
                {/* Franquias por Estado */}
                <div className="col-md-6 mb-3">
                    <div className="card   ">
                        <div className="card-header bg-primary text-white">
                            Franquias por Estado
                        </div>
                        <div className="card-body card-uf overflow-y-auto">
                            <table className="table table-striped ">
                                <thead>
                                    <tr>
                                        <th>Estado</th>
                                        <th>Quantidade</th>
                                        <th>%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dadosSeparados.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.uf_franquia}</td>
                                            <td>{item.qtd}</td>
                                            <td>{((item.qtd / totalFranquias) * 100).toFixed(1)}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>



                {/* Distribuição por Modalidade com cálculo dinâmico */}
                <div className="col-md-6 mb-3">
                    <div className="card h-100">
                        <div className="card-header bg-secondary text-white">
                            Distribuição por Modalidade
                        </div>
                        <div className="card-body">
                            {modalidadesData.map((item, index) => {
                                const percent = ((item.quantidade / totalModalidades) * 100).toFixed(1);
                                return (
                                    <div key={index} className="mb-3">
                                        <strong>{item.modalidade}:</strong> {percent}%
                                        <div className="progress">
                                            <div
                                                className="progress-bar bg-success"
                                                style={{ width: `${percent}%` }}
                                                role="progressbar"
                                                aria-valuenow={percent}
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                            ></div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* Distribuição por Grupo com cálculo dinâmico */}
                <div className="col-md-6 mb-3">
                    <div className="card h-100">
                        <div className="card-header bg-info text-white">
                            Distribuição por Grupo
                        </div>
                        <div className="card-body">
                            {arrayGrupos.map((item, index) => {
                                const percent = ((item.valor / totalGrupos) * 100).toFixed(1);
                                return (
                                    <div key={index} className="mb-3">
                                        <strong>{item.grupo} : </strong>{percent}%
                                        <div className="progress">
                                            <div
                                                className="progress-bar bg-primary"
                                                style={{ width: `${percent}%` }}
                                                role="progressbar"
                                                aria-valuenow={percent}
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                            ></div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* Franquias por Região */}
                <div className="col-md-6 mb-3">
                    <div className="card   ">
                        <div className="card-header bg-success text-white">
                            Distrubuição por Região
                        </div>
                        <div className="card-body card-uf ">
                            <table className="table table-striped ">
                                <thead>
                                    <tr>
                                        <th>Região</th>
                                        <th>Quantidade</th>
                                        <th>%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {arrayRegioes.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.regiao}</td>
                                            <td>{item.qtd}</td>
                                            <td>{((item.qtd / totalFranquias) * 100).toFixed(1)}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


            </div>

            {/* Área de Gráficos (Placeholder) */}
            <div className="row mt-4 mb-5">
                <div className="col-md-12">
                    <div className="card h-100">
                        <div className="card-header bg-dark text-white">
                            Gráficos de Comparação
                        </div>
                        <div className="card-body text-center">
                            <img
                                src="https://via.placeholder.com/800x400?text=Gr%C3%A1ficos+Comparativos"
                                alt="Gráficos Comparativos"
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default DashboardFranquias;